import {Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy} from '@angular/core';
import {MatMenu} from '@angular/material/menu';

@Component({
    selector: 'app-split-button',
    templateUrl: './split-button.component.html',
    styleUrls: ['./split-button.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SplitButtonComponent implements OnInit {

  @Input() menu: MatMenu;
  @Input() value: string;
  @Output() mainClick = new EventEmitter<Event>();

  constructor() { }

  ngOnInit(): void {
  }

  onMainClick(event: Event): void {
    this.mainClick.emit(event);
  }

}
